<template>
  <ClientOnly><NuxtLoadingIndicator color="#FF6C9B" :throttle="0" :height="3" /></ClientOnly>
  <NuxtLayout> </NuxtLayout>
</template>

<script setup>
// <VitePwaManifest />
import { pageQuery } from "@/apollo/queries/PageQuery.gql";
import { routeFix } from "@/lib/tools";
import { friendlyCountryBrand } from "@/apollo/queries/FriendlyCountries.gql";

const router = useRouter();
const route = useRoute();
// const headers = useRequestHeaders();
const url = useRequestURL();

if (import.meta.dev) pageQuery.cache = "no-cache";

const runtimeConfig = useRuntimeConfig();

let hostname = import.meta.dev ? runtimeConfig.public.hostname || url.host : url.host;
if (typeof window !== "undefined" && window.hostBase) hostname = window.hostBase;

const initQueries = [];
const pageData = ref({});

const friendlyCountries = ref([]);
const friendlyCountryBanner = ref({});
const {
  clients: { default: apollo },
} = useApollo();
// console.log("apollo", apollo);

initQueries.push(
  apollo
    .query({
      query: pageQuery,
      variables: {
        hostname,
        uri: routeFix(route.path),
      },
    })
    .then(res => {
      // console.log("res", res);
      pageData.value = res;
    })
);

// initQueries.push(
//   useAsyncQuery(pageQuery, {
//     hostname,
//     uri: routeFix(route.path),
//   }).then(({ data, error }) => {
//     pageData.value = { data, error: error.value || error };
//   })
// );

if (navigator?.language || navigator?.userLanguage) {
  friendlyCountries.value = [
    "AL",
    "AR",
    "AT",
    "BA",
    "BE",
    "BG",
    "BR",
    "CH",
    "CZ",
    "DE",
    "DK",
    "EE",
    "ES",
    "FI",
    "FR",
    "GR",
    "HR",
    "HU",
    "ID",
    "IE",
    "IL",
    "IN",
    "IT",
    "JP",
    "LT",
    "LV",
    "MX",
    "MY",
    "NG",
    "NL",
    "NO",
    "PH",
    "PL",
    "PT",
    "RO",
    "RS",
    "SE",
    "SI",
    "SK",
    "TH",
    "TR",
    "UA",
    "VE",
    "VN",
    "KN",
    "BD",
  ];

  const userLang = navigator?.language || navigator?.userLanguage; // for dev test  = "ES"
  const country = userLang && userLang.includes("-") ? userLang.split("-")[1].toUpperCase() : "US";
  if (friendlyCountries.value.includes(country)) {
    // get replacement banner for selected country if available and set it
    initQueries.push(
      apollo
        .query({
          query: friendlyCountryBrand,
          variables: {
            country,
          },
        })
        .then(res => {
          friendlyCountryBanner.value = res.data.friendlyCountryBrand?.banner || {};
        })
    );

    // initQueries.push(
    //   useAsyncQuery(friendlyCountryBrand, { country }).then(({ data, error }) => {
    //     if (error.value) {
    //       console.log(unref(error));
    //     }
    //     friendlyCountryBanner.value = data.value?.friendlyCountryBrand?.banner || {};
    //   })
    // );
  }
}

await Promise.all(initQueries);

// const layout = runtimeConfig.public.layout;
// console.log("variables", JSON.stringify({ hostname, uri: routeFix(route.path) }));

// const { data, error } = await useAsyncQuery(pageQuery, {
//   hostname,
//   uri: routeFix(route.path),
// });
const { data, error } = pageData.value;
if (error) {
  console.log(unref(error));
  const event = useRequestEvent();
  setResponseStatus(event, 500);
}

if (_.get(unref(data), ["pageQuery", "page", "uri"], {}) === "404.html") {
  const event = useRequestEvent();
  setResponseStatus(event, 404);
}

const page = ref(injectA(data, url));
page.value.removeRegion = region => {
  if (page?.value?.blocks && page.value.blocks[unref(region)]) delete page.value.blocks[unref(region)];
};

provide("page", readonly(page));
provide("friendlyCountries", readonly(friendlyCountries));
provide("friendlyCountryBanner", readonly(friendlyCountryBanner));
provide("apollo", apollo);

// console.log("friendlyCountryBanner", friendlyCountryBanner.value);

// console.log("pagereadonly(page));
// console.log("page.hostname", unref(page).hostname);

const head = computed(() => _.get(unref(page), "meta"));
useHead(head);

// router.beforeEach((to, from) => {
//   if (!_.isEqual(to, from)) {
//     useAsyncQuery(pageQuery, { hostname, uri: routeFix(to.path) }).then(res => {
//       page.value = injectA(res.data);
//       if (window) window.scrollTo(0, 0);
//     });
//   }
// });

router.afterEach((to, _from) => {
  // console.log("afterEach", routeFix(to.path), _from, page.value.uri);
  // if (!_.isEqual(to, from)) {
  if (routeFix(to.path) !== page.value.uri) {
    // console.log("afterEach!", window.document.location.href);

    // useAsyncQuery(pageQuery, { hostname, uri: routeFix(to.path) }).then(res => {
    //   page.value = injectA(res.data, url);
    //   if (window) window.scrollTo(0, 0);
    // });
    apollo
      .query({
        query: pageQuery,
        variables: {
          hostname,
          uri: routeFix(to.path),
        },
      })
      .then(res => {
        page.value = injectA(res.data, url);
        if (window) window.scrollTo(0, 0);
      });
  }
});
</script>
